export const steps = [
  {
    id: 'sync-users',
    icon: 'mdi-check',
    title: 'User Sync',
    description:
      'Connect your Office 365 account to manage Users and Group membership linked to the content in the archive.'
  },
  // {
  //   id: 'payment-method',
  //   title: 'Payment Method',
  //   description: 'Please add your preferred payment method.'
  // },
  {
    id: 'sso',
    title: 'Configure Single Sign-On',
    shortTitle: 'Configure SSO',
    description:
      'Enable Single Sign-On to log in to Xift using your Office 365 account credentials. '
  },

  {
    id: 'activate-connectors',
    title: 'Configure Connectors',
    description:
      'Enable each of the connectors to begin the ingest process and stay synchronised with new content. '
  },
  // {
  //   id: 'mail-sync',
  //   title: 'Mail Synchronization',
  //   description: 'Sync your emails to Xift. '
  // },
  {
    id: 'complete',
    title: 'Setup complete',
    description:
      'Thank you for completing your account setup. You can change settings at any time in the Configuration menu.'
  }
  // {
  //   id: 'complete',
  //   title: 'Thanks !',
  //   description:
  //     'Thank you for completing the Xift account setup. You can change settings at any time in the Configuration menu.'
  // }
];

export const stepKeys = {
  USER_GROUP: 1,
  // PAYMENT_METHOD: 2,
  SSO: 2,
  CONNECTORS: 3,
  // MAIL_SYNC: 4,
  THANKS: 4,
  ONBOARDED: 5
};

export const dialogText =
  'Xift needs connectors to your data sources to be able to archive your content and provide Search and eDiscovery features.';
